import { useId, useState } from 'react'
import { Button, Dialog, FormField } from '../common'

export default function PromptPresetNameDialog({
  open,
  isDefault = false,
  initialName = '',
  saving = false,
  onConfirm,
  onCancel,
}) {
  const formId = useId()
  const [name, setName] = useState(initialName)
  const [attempted, setAttempted] = useState(false)
  const trimmedName = name.trim()

  const handleSubmit = (event) => {
    event.preventDefault()
    setAttempted(true)
    if (!trimmedName || saving) return
    onConfirm?.(trimmedName)
  }

  return (
    <Dialog
      open={open}
      title={isDefault ? 'Save default prompt preset' : 'Save prompt preset'}
      description={isDefault
        ? 'This preset will replace the current default prompt direction for the organization.'
        : 'Save this prompt direction for reuse in the organization.'}
      size="small"
      dismissable={!saving}
      hideCloseButton={saving}
      onClose={onCancel}
      footer={(
        <>
          <Button type="button" variant="secondary" disabled={saving} onClick={onCancel}>Cancel</Button>
          <Button type="submit" form={formId} loading={saving}>
            {isDefault ? 'Save default' : 'Save prompt'}
          </Button>
        </>
      )}
    >
      <form id={formId} onSubmit={handleSubmit} noValidate>
        <FormField
          label={isDefault ? 'Default preset name' : 'Preset name'}
          value={name}
          required
          error={attempted && !trimmedName ? 'Enter a preset name.' : undefined}
          data-autofocus
          onChange={(event) => {
            setName(event.target.value)
            if (attempted) setAttempted(false)
          }}
        />
      </form>
    </Dialog>
  )
}
